import { Dayjs } from "dayjs";
import { CraneShift } from "src/store/api/generatedApi";

export const SHIFTS_PER_FETCH = 20;

export interface ShiftsState {
  shifts: CraneShift[];
  selectedIndex: number;
  isStale: boolean;
  targetTime: string | undefined;
}

export const initialShiftsState: ShiftsState = {
  shifts: [],
  selectedIndex: 0,
  isStale: false,
  targetTime: undefined,
};

export const shiftsActions = {
  addShifts: (shifts: CraneShift[], fromCache: boolean) => ({
    type: "ADD_SHIFTS" as const,
    shifts,
    fromCache,
  }),

  setTargetTime: (targetTime: string | undefined) => ({
    type: "SET_TARGET_TIME" as const,
    targetTime,
  }),

  selectPrevious: () => ({
    type: "SELECT_PREVIOUS" as const,
  }),

  selectNext: () => ({
    type: "SELECT_NEXT" as const,
  }),
};

export type ShiftsAction = ReturnType<
  (typeof shiftsActions)[keyof typeof shiftsActions]
>;

export interface UseShiftsOptions {
  initialShiftStartTime?: string | null;
  onShiftChange?: (shiftStartTime: string) => void;
  bufferSize?: number;
}

export interface UseShiftsResult {
  shifts: CraneShift[];
  selectedShift: CraneShift | null;
  selectedIndex: number;
  canGoBack: boolean;
  canGoForward: boolean;
  goToPreviousShift: () => Promise<void>;
  goToNextShift: () => Promise<void>;
  selectShift: (shift: CraneShift) => void;
  goToTimestamp: (timestamp: Dayjs) => Promise<void>;
  goToDate: (date: Dayjs, timezone: string) => Promise<void>;
  isFetching: boolean;
  isLoading: boolean;
  isError: boolean;
}
